module.exports = __webpack_public_path__ + "static/media/wireframe.0212d73b.mp4";